import {GROUP_TYPE_ADMIN_SUB, USER_ROOT, GROUP_TYPE_ADMIN, GROUP_TYPE_PARENT} from '~/contants/base';
import map from 'lodash/map';
import flatten from 'lodash/flatten';
import Vue from 'vue';

Vue.directive('click-outside-custom', {
  bind(el, binding, vnode) {
    var vm = vnode.context;
    var callback = binding.value;

    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        return callback.call(vm, event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
});

export default function ({store, route}, inject) {
  const bus = new Vue();

  inject('isRoot', () => {
    return store.state.frontend.auth.user.profile.is_root == USER_ROOT;
  });

  inject('isSubRoot', () => {
    const groups = store.state.frontend.auth.user.groups;
    let isSubRoot = false;
    if (groups) {
      groups.forEach(group => {
        if (group.type == GROUP_TYPE_ADMIN_SUB) {
          isSubRoot = true;
          return;
        }
      });
    }

    return isSubRoot;
  });

  inject('busEmit', (eventName, params) => {
    bus.$emit(eventName, params)
  })

  inject('busOnce', (eventName, params) => {
    bus.$once(eventName, params)
  })

  inject('companyHasRole', (roleName) => {
    const company = store.state.frontend.auth.user.workspace;
    if (!company.plan_id && roleName !== 'application') {
      return true;
    }
    const roles = store.state.frontend.auth.user.workspace.roles;
    const index = roles.findIndex(role => role.name === roleName);
    return index >= 0;
  })

  inject('hasPermission', (roles) => {
    if(!store.state.frontend.auth.user) {
      return false;
    }
    const groups = store.state.frontend.auth.user.groups;
    let permissions = flatten(map(groups, 'permissions'));
    permissions = [...new Set(map(permissions, 'name'))];

    if(store.state.frontend.auth.user.profile.is_root == USER_ROOT) {
      return true;
    }

    if(groups) {
      groups.forEach(group => {
        group.categories.forEach(category => {
          permissions.push(
            (category.pivot.full_access ? 'document_full_' : 'document_read_') + category.id
          )
        })
      });
    }

    if (permissions.includes('settings')) {
      return true;
    }

    if(!Array.isArray(roles)) {
      roles = [roles];
    }

    return !!permissions.find(permission => {
      return roles.includes(permission);
    })
  })

  inject('planHasPermission', (roles)=>{
    const permission = store.state.frontend.auth.user.planPermission;
    if (Object.keys(permission).length) {
      return Boolean(permission[roles]);
    }

    return true;
  });

  inject('nl2br', (str, is_xhtml) => {
    if (typeof str === 'undefined' || str === null) {
      return '';
    }
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
  })
 
  inject('redirectPathDefault', ()=>{
    const permission = store.state.frontend.auth.user.planPermission;
    const user = store.state.frontend.auth.user;
    const isRoleApplication = store.state.frontend.auth.isRoleApplication;

    const dashboardList = ['view_calendar', 'view_proposal_month', 'view_todo_month', 'view_memo', 'view_activity', 'view_approve_document'];
    if (isHasRoleApplication(user)) {
      return {path: '/dashboard', name: 'dashboard'};
    }
    let dashboardPermissioon = false;
    dashboardList.forEach(role => {
      if( planHasPermission(permission, role)) {
        dashboardPermissioon = true;
      }
      if (isRoleApplication) {
        dashboardPermissioon = true;
      }
    })
    if (!dashboardPermissioon) {
      if (planHasPermission(permission, 'proposal_view') &&  hasPermission(user, 'accept_from_ls')) {
          return {path: '/proposals', name: 'proposals'};
      }
      if (planHasPermission( permission,'crud_todo')) {
          return {path: '/todo', name:'todo'};
      }
      if (planHasPermission(permission, 'crud_manual')) {
          return {path: '/templates', name:'templates'};
      }
      if (planHasPermission(permission, 'view_works') && hasPermission(user, 'accept_from_ls')) {
          return {path: '/works', name: 'works'};
      }
      if (planHasPermission(permission, 'crud_document')) {
          return {path: '/document', name:'document'};
      }
      if (planHasPermission(permission, 'application_view')) {
        return {path: '/applications/list', name:'applications-list'};
      }
      if (planHasPermission(permission, 'download_document_template')) {
        return {path: '/document-templates', name:'document-templates'};
      }
      if (planHasPermission(permission, 'manage_group_chat')) {
          return {path: '/group-chats', name: 'group-chats'};
      }

      let settingPermisson = false;
      user.groups.forEach(group => {
        if(group.type == GROUP_TYPE_PARENT 
          || group.type == GROUP_TYPE_ADMIN  
          || group.type == GROUP_TYPE_ADMIN_SUB)
        {
          settingPermisson = true;
        }
      });
      if(settingPermisson) {
        return {path: '/settings', name: 'settings'};
      }
      return {path: '/request-group', name: 'request-group'};
    }
    else {
      return {path: '/dashboard', name: 'dashboard'}
    }
  });
  inject('getPluckIds', (data, property = 'id')=>{
    if (!data || !Array.isArray(data)) {
      return []
    }
  
    if (data[0] && data[0][property]) {
      return data.map(item => item[property])
    }
    return data
  });
}

function planHasPermission(permission, roles) {
  if(Object.keys(permission).length === 0) {
    if (roles === 'application_view') {
      return false;
    }
    return true;
  }

  if (permission[roles]) {
    return true;
  }
  return false;
};

function hasPermission(user, roles) {
  if(!user) {
    return false;
  }
  const groups = user.groups;
  let permissions = flatten(map(groups, 'permissions'));
  permissions = [...new Set(map(permissions, 'name'))];

  if(user.profile.is_root == USER_ROOT) {
    return true;
  }

  if(groups) {
    groups.forEach(group => {
      group.categories.forEach(category => {
        permissions.push(
          (category.pivot.full_access ? 'document_full_' : 'document_read_') + category.id
        )
      })
    });
  }

  if (permissions.includes('settings')) {
    return true;
  }

  if(!Array.isArray(roles)) {
    roles = [roles];
  }

  return !!permissions.find(permission => {
    return roles.includes(permission);
  })
}

function isHasRoleApplication(user) {
  const planPermissions = user.planPermission instanceof Object
		? Object.keys(user.planPermission)
		: [];
	const roleApplications = [
		'application_view',
		'download_document_template',
	];

	return user.is_role_application 
		&& planPermissions.length === roleApplications.length
		&& roleApplications.every(role => user.planPermission[role]);
}
